// Marketing migrations registry.
//
// #786 — Provider-agnostic social publishing data model.
// #792 — Social post insights snapshots.
import type { ModuleMigrationDef } from "@kubdee/sdk";
import { migration as initial } from "./001_initial";
import { migration as postInsightsSnapshots } from "./002_post_insights_snapshots";

export const migrations: ModuleMigrationDef[] = [initial, postInsightsSnapshots];
